import Vue from 'vue'
import Vuex from 'vuex'
import curtain from './modules/curtain'
import locale from './modules/locale'
import modal from './modules/modal'
import mobile from './modules/mobile'
import lk from './modules/lk'
import meta from './modules/meta'
import events from './modules/events'
import portal from './modules/portal'
import questionnaries from './modules/questionnaries'
import ratingHistory from './modules/lk-rating-history'
import form from './modules/form'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    curtain,
    locale,
    mobile,
    modal,
    lk,
    meta,
    events,
    portal,
    questionnaries,
    ratingHistory,
    form,
  },
  strict: process.env.NODE_ENV !== 'production',
})



// WEBPACK FOOTER //
// ./src/legacy/store/index.js